export const StateroomsMap = {
  "Ocean View - O5": {
    img_name: ["paradise ocean view"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-picturesque-oceanview-staterooms",
    short_desc:
      "Enjoy scenic ocean views along with extra lounge space (hello sitting area!), chic décor, and an ultra-comfy layout. Wake up to relaxing sunrises over the water or count the stars in the night sky right from the comfort of your room. This is one of our most popular staterooms for a reason.",
    priority: 1,
    ship: 61,
  },
  "Ocean View - O4": {
    img_name: ["paradise ocean view"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-picturesque-oceanview-staterooms",
    short_desc:
      "Enjoy scenic ocean views along with extra lounge space (hello sitting area), chic décor, and an ultra-comfy layout. This stateroom is located on upper decks to give you an elevated ocean view and convenient location, putting just a few steps between you and our favorite dining and entertainment spots.",
    priority: 5,
    ship: 61,
  },
  "Grand Terrace Suite - S1": {
    img_name: ["paradise grand terrace suite"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-luxurious-grand-terrace-suites",
    short_desc:
      "There’s no better way to cruise to paradise. Our most exclusive of all the balcony suites, this impressive stateroom provides the perfect private getaway. Lounge luxuriously with a host of premium amenities, including a queen bed, pull-out sofa bed, scenic balcony, large jetted tub, and so much more.",
    priority: 7,
    ship: 61,
  },
  "Jr Suite - S3": {
    img_name: ["paradise grand terrace suite"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-picturesque-oceanview-staterooms",
    short_desc:
      "A perfect blend of comfort and style, the exclusive Junior Suites provide plenty of space to stretch out and unwind while offering wide-open views from two large porthole windows. With a pull-out sofa bed, multiple desks, flexible seating and ample closets and storage space, these suites are an idyllic landing spot after an adventurous day above deck.",
    priority: 6,
    ship: 61,
  },
  "Interior Stateroom - I6": {
    img_name: ["paradise interior staterooms"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-cozy-interior-staterooms",
    short_desc:
      "Lounge stylishly in these comfortable and cozy interior staterooms. For just a bit more than our other interior staterooms, enjoy the best location on the highest decks for the easiest access to dining, pools and entertainment.",
    priority: 2,
    ship: 61,
  },
  "Interior Stateroom - I7": {
    img_name: ["paradise interior staterooms"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-cozy-interior-staterooms",
    short_desc:
      "Lounge stylishly in these comfortable and cozy interior staterooms. For just a bit more than our other interior staterooms, enjoy a better location on higher decks.",
    priority: 3,
    ship: 61,
  },
  "Interior Stateroom - I8": {
    img_name: ["paradise interior staterooms"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-cozy-interior-staterooms														",
    short_desc:
      "Lounge stylishly in these comfortable and cozy interior staterooms. Economical without sacrificing quality, this accommodation is the best value and serves as a perfect base for a most memorable cruise experience.",
    priority: 1,
    ship: 61,
  },
  "Partial Ocean View Staterooms": {
    img_name: [
      "islander ocean view stateroom-1",
      "islander ocean view",
      "islander ocean view stateroom-2",
    ],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/partial-view-oceanview-staterooms",
    short_desc:
      "These staterooms are adjacent to the promenade and feature large windows for plenty of natural light. A great value, these Ocean View staterooms are also good for families, as they are located on the same deck as our Jolly Mon and Parakeets Kids' Clubs.",
    priority: 2,
    ship: 77,
  },
  "Picturesque Oceanview Staterooms": {
    img_name: ["islander ocean view"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/picturesque-oceanview-staterooms",
    short_desc:
      "Enjoy scenic ocean views along with casual chic decor featuring separate vanity and stool, spacious storage areas, and super-soft pillows and linens. Wake up to relaxing sunrises over the water or count the stars in the night sky right from the comfort of your room.",
    priority: 3,
    ship: 77,
  },
  "Grand Terrace Suite": {
    img_name: [
      "islander grand terrace suite stateroom-1",
      "islander grand terrace suite stateroom-2",
    ],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/paradise/accommodations/the-luxurious-grand-terrace-suites",
    short_desc:
      "There’s no better way to cruise to paradise than with these impressive balcony staterooms with separate seating area, upgraded linens and pillows, and comfy lounge sofa, accompanied by premium amenities like concierge services, complimentary nightly dining in the Islander Dining Room and priority boarding, check-in and debarkation for the ultimate voyage to an island state of mind",
    priority: 9,
    ship: 77,
  },
  "Wake View Balcony": {
    img_name: ["islander balcony wakeview", "islander balcony stateroom-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/wake-view-balcony-staterooms",
    short_desc:
      "Located at the aft of the Islander, these balcony staterooms feature picturesque open views of the ocean with spacious outdoor lounge area and additional outdoor furniture, perfect for inviting your shipmates along to watch stunning sunsets.",
    priority: 7,
    ship: 77,
  },
  "Premium Extended Balcony": {
    img_name: ["islander balcony premiumExt", "islander balcony stateroom-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/premium-extended-balcony-staterooms",
    short_desc:
      "These extra-large balconies are idyllic retreats for recharging in between deck parties and casino nights, featuring outdoor lounge furniture, separate vanity and stool, spacious storage areas, casual-luxe décor and super-soft pillows and linens.",
    priority: 8,
    ship: 77,
  },
  "Extended Balcony Stateroom": {
    img_name: ["islander balcony extended", "islander balcony stateroom-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/extended-balcony-staterooms",
    short_desc:
      "All the comfort and style as standard Breezy Balconies with additional balcony space to stretch out and lounge, featuring separate vanity and stool, spacious storage areas, casual-luxe décor and super-soft pillows and linens.",
    priority: 6,
    ship: 77,
  },
  "Breezy Balcony Stateroom": {
    img_name: ["islander balcony breezy", "islander balcony stateroom-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/breezy-balcony-staterooms",
    short_desc:
      "Escape to paradise with gentle breezes and stunning views as you adventure from port to port in your own private stateroom retreat featuring separate vanity and stool, spacious storage areas, casual-luxe décor and super-soft pillows and linens.",
    priority: 5,
    ship: 77,
  },
  "Partial View Balcony": {
    img_name: ["islander balcony breezy", "islander balcony stateroom-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/partial-view-balcony-staterooms",
    short_desc:
      "Enjoy the same breezy escape as standard Breezy Balconies with a partial or fully obstructed view located adjacent to the open promenade, featuring separate vanity and stool, spacious storage areas, casual-luxe décor and super-soft pillows and linens.",
    priority: 4,
    ship: 77,
  },
  "Grand Terrace Corner Suite": {
    img_name: [
      "islander corner suite stateroom-1",
      "islander corner suite stateroom-2",
      "islander corner suites",
    ],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/grand-terrace-corner-suites",
    short_desc:
      "Bliss out in indoor-outdoor luxury with an extra-spacious wraparound balcony and an impressive interior featuring spacious bathrooms with double sinks, separate seating areas, upgraded linens and pillows, and a comfy lounge sofa, along with premium amenities like concierge services, complimentary nightly dining in the Islander Dining Room and priority boarding, check-in and debarkation.",
    priority: 11,
    ship: 77,
  },
  "Serene Junior Suite": {
    img_name: ["islander serene junior suite"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/serene-junior-suites",
    short_desc:
      "A perfect blend of comfort and style, Junior Suites provide plenty of space to stretch out and unwind with wide-open balcony views, casual chic décor, comfy lounge sofa, separate vanity and storage space, and more. Enhanced amenities like concierge services, priority boarding, check-in and debarkation, nightly dining in the Islander Dining Room and more round out an accessible luxury experience to accompany a premium stateroom.",
    priority: 9,
    ship: 77,
  },
  "Cozy Interior Staterooms": {
    img_name: ["islander interior"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/cozy-interior-staterooms",
    short_desc:
      "Lounge stylishly in these comfortable and cozy interior staterooms. Economical without sacrificing quality, this accommodation is an incredible value and serves as the perfect base for a most memorable cruise experience.",
    priority: 1,
    ship: 77,
  },
  '"Live Life Like a Song” Signature Grand Suites': {
    img_name: ["Islander_JWBSuite-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/cozy-interior-staterooms",
    short_desc: `Unwind in a uniquely themed experience in your one-of-a-kind Signature Grand Suite, inspired by the iconic songs of Jimmy Buffett and featuring uniquely Margaritaville touches throughout. From the "Come Monday," to the "Everlasting Moon," these six ultra-luxury suites offer extra spacious balconies with private sun loungers, large walk-in showers, upgraded premium furnishings, separate seating area, upgraded linens and pillows, mini bar and the highest class of premium amenities.`,
    priority: 12,
    ship: 77,
  },
  default: {
    img_name: ["Islander_JWBSuite-1"],
    long_desc:
      "https://margaritavilleatsea.com/explore-our-ships/islander/accommodations/cozy-interior-staterooms",
    short_desc: `Unwind in a uniquely themed experience in your one-of-a-kind Signature Grand Suite, inspired by the iconic songs of Jimmy Buffett and featuring uniquely Margaritaville touches throughout. From the "Come Monday," to the "Everlasting Moon," these six ultra-luxury suites offer extra spacious balconies with private sun loungers, large walk-in showers, upgraded premium furnishings, separate seating area, upgraded linens and pillows, mini bar and the highest class of premium amenities.",    priority: `,
    priority: 0,
    ship: 0,
  },
};
